import { useEffect } from 'react';
import { useHistory } from 'react-router';
import { clearLocalStorage } from '../../helpers/localStorageKeyHelper';

const ClearCachePage = () => {
  const history = useHistory();
  useEffect(() => {
    clearLocalStorage();
    history.push('/');
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- FIXME: pre-existing error: React Hook useEffect has a missing dependency: 'history'
  }, []);
  return null;
};

export default ClearCachePage;
